import { CompanyTitledPage } from "../../TitledPage";
import { useSalesRecordCollectiveEntry } from "./hooks/useSalesRecordCollectiveEntry";
import SearchBox from "./component/SearchBox";
import EntryTablePart from "./component/entryTablePart/EntryTablePart";
import ErrorMessageBox from "../../../components/ErrorMessageBox";
import QrPreviewDialog from "./component/QrPreviewDialog";

function SalesRecordCollectiveEntryPage() {
  
  const entry = useSalesRecordCollectiveEntry();

  return (
    <CompanyTitledPage title="販売原票一括入力">

      <SearchBox
        states={entry.searchBoxStates}
        onClickSearch={entry.search}
      />
      <ErrorMessageBox
        messages={entry.errorMessages}
      />
      <EntryTablePart
        products={entry.entryProducts}
        control={entry.entryTableControl}      
      />

      <QrPreviewDialog
        dialogStatus={entry.qrPreviewDialogStates}
      />
      
    </CompanyTitledPage>
  );
}

export default SalesRecordCollectiveEntryPage;